module.exports = __webpack_public_path__ + "static/media/replace.69b52651.svg";